import { registerBlockType } from "@wordpress/blocks"
import Edit from "./edit"

registerBlockType("puroclean/services-overview", {
  edit: Edit,
  save: () => null // Server-side rendered block
}) 